angular.module('unergie.main')
.controller('salesTunnelV2Ctrl', (
    $scope, $rootScope, $q, $timeout, $state, $stateParams, $window, mapUtils, DataAccess, DataAccessSearch, LandscapeQuestions, ModalService, SocketFactory,
    AlertManager, BoFeaturesService, ApiUser, ReferencesService, MetaWatcher, AuthService, EventProcessorService, ErrorCatcher
) => {
    if ($stateParams.draft) {
        SocketFactory.join($stateParams.draft, $scope)
    }

    const BULK_PURCHASE_TO_OMIT = [
        'plan',
    ]
    // --- Global --- #
    // Shared object between component
    // Should be grouped in immutable store object ?
    const initData = function () {
        $scope.draft = null
        $scope.user = null
        $scope.prm = {
            id_prm: null,
            prmOk: null,
            prmResult: undefined,
            plan_id: undefined,
            id_p_calendar: undefined,
        }
        $scope.landscape = {
            landscapeRequired: null,
            landscapeDone: false,
        }
        $scope.draftState = {
            history: [],
            isUpdating: false,
            error: null,
            disableContractEdition: false,
        }
        $scope.readings = {
            base: undefined,
            hp: undefined,
            hc: undefined,
        }
        $scope.subscriptionPrice = {
            simulationResult: {},
            refResult: {},
        }
        $scope.checks = {
            mailSent: false,
            mailBounced: false,
            mailVerified: false,
            mandateSignature: false,
            transformed: false,
            needInter: false,
        }
        $scope.initialReadings = {}
        $scope.toggleView = false
        $scope.validators = {}
        $scope.validated = {}
        $scope.validation = {}
        $scope.shootDraftMessage = ['Cliquez sur le bouton Envoyer pour générer le contrat']
    }
    initData()
    $scope.showTools = !BoFeaturesService.get('isEnvProd')

    $scope.isAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])

    $scope.onToggleView = () => {
        $scope.toggleView = !$scope.toggleView
    }

    // VALIDATORS
    $scope.validate = () => {
        // VALIDATOR DEFINED ON EACH COMPOPENT
        // GROUPS VALIDATOR RULES PER COMPONENT AND GIVE A VALIDATOR NAME TO SIMPLIFY DEBUGGING
        const validateWithContext = (store) => (fn) => {
            $scope.validation[fn.name] = fn(store)
            mapUtils.orderMap($scope.validation)
            return $scope.validation[fn.name]
        }
        const validatedPromise = _.mapValues($scope.validators, validateWithContext({
            draft: $scope.draft,
            prm: $scope.prm,
            landscape: $scope.landscape,
            readings: $scope.readings,
            user: $scope.user,
            checks: $scope.checks,
            disableContractEdition: $scope.disableContractEdition,
        }))
        $q.all(validatedPromise).then((validated) => {
            const all = _.every(validated, (val) => val === true)
            $scope.validated = _.assign({}, validated, { all })
        })
    }

    // INCREMENTAL SAVE
    $scope.saveDraft = (payload) => {
        // Core code to update draft data
        $scope.draftState = _.assign({}, $scope.draftState, {
            isUpdating: true,
            error: null,
            history: [payload].concat($scope.draftState.history),
        })

        return DataAccess.updateDraftById({ id: $scope.draft.id }, _.omit(payload, BULK_PURCHASE_TO_OMIT)).$promise.then(() => {
            return DataAccess.getDraftById({ idDraft: $scope.draft.id, withRelated: 'landscapeDone,providerOffer' }).$promise
        })
        .then((draft) => {
            $scope.draft = draft
            $scope.validate()
            return draft
        }).catch((error) => {
            ErrorCatcher(error)
            $scope.draftState = _.assign({}, $scope.draftState, { error })
        }).finally(() => {
            $scope.draftState = _.assign({}, $scope.draftState, { isUpdating: false })
        })
    }

    $scope.reloadDraft = () => {
        $scope.saveDraft({})
    }

    $scope.saveUser = (payload) => {
        $scope.user = payload
        $scope.validate()
    }

    $scope.savePrm = (prm) => {
        $scope.prm = _.assign({}, $scope.prm, prm)
        $scope.validate()
    }

    $scope.saveLandscape = (landscape) => {
        $scope.landscape = _.assign({}, $scope.landscape, landscape)
        $scope.validate()
    }

    $scope.saveSubscriptionPrice = (subscriptionPrice) => {
        $scope.subscriptionPrice = _.assign({}, subscriptionPrice)
        $scope.validate()
    }

    $scope.saveReadings = (readings) => {
        $scope.readings = _.assign({}, $scope.readings, readings)
        $scope.validate()
    }

    $scope.saveChecks = (checks) => {
        $scope.checks = _.assign({}, $scope.checks, checks)
        $scope.validate()
    }

    $scope.saveDraftState = (draftState) => {
        $scope.draftState = _.assign({}, $scope.draftState, draftState)
        $scope.validate()
    }

    $scope.updateValidators = (validators) => {
        $scope.validators = _.assign({}, $scope.validators, validators)
        $scope.validate()
    }

    $scope.logShootDraft = (msg) => {
        $scope.shootDraftMessage = [msg].concat($scope.shootDraftMessage)
    }

    $scope.showQuotation = () => {
        // eslint-disable-next-line eqeqeq
        return $scope.landscape.landscapeRequired === true || ($scope.draft.primary_residence != undefined && $scope.draft.heating)
    }

    const initWatchers = () => {
        MetaWatcher.watch('SALES_TUNNEL.RELOAD_DRAFT', 'salesTunnelV2Ctrl', $scope, $scope.reloadDraft)
        MetaWatcher.watch('SALES_TUNNEL.SAVE_DRAFT', 'salesTunnelV2Ctrl', $scope, $scope.saveDraft)
        MetaWatcher.watch('SALES_TUNNEL.SAVE_USER', 'salesTunnelV2Ctrl', $scope, $scope.saveUser)
        MetaWatcher.watch('SALES_TUNNEL.SAVE_PRM', 'salesTunnelV2Ctrl', $scope, $scope.savePrm)
        MetaWatcher.watch('SALES_TUNNEL.SAVE_LANDSCAPE', 'salesTunnelV2Ctrl', $scope, $scope.saveLandscape)
        MetaWatcher.watch('SALES_TUNNEL.SUBSCRIPTION_PRICE', 'salesTunnelV2Ctrl', $scope, $scope.saveSubscriptionPrice)
        MetaWatcher.watch('SALES_TUNNEL.SAVE_READINGS', 'salesTunnelV2Ctrl', $scope, $scope.saveReadings)
        MetaWatcher.watch('SALES_TUNNEL.SAVE_CHECKS', 'salesTunnelV2Ctrl', $scope, $scope.saveChecks)
        MetaWatcher.watch('SALES_TUNNEL.SAVE_DRAFT_STATE', 'salesTunnelV2Ctrl', $scope, $scope.saveDraftState)
        MetaWatcher.watch('SALES_TUNNEL.SET_VALIDATORS', 'salesTunnelV2Ctrl', $scope, $scope.updateValidators)
        MetaWatcher.watch('SALES_TUNNEL.LOG_SHOOT_DRAFT', 'salesTunnelV2Ctrl', $scope, $scope.logShootDraft)
        MetaWatcher.watch('SALES_TUNNEL.REVALIDATE', 'salesTunnelV2Ctrl', $scope, $scope.validate)
    }

    // INITIAL INFO
    const fetchInitialInfo = () => {
        $timeout(() => {
            let promises = $q.reject('')
            if ($stateParams.user) {
                promises = $q.all({
                    users: DataAccessSearch({ limit: 1 }).search({ resource: 'accounts', id: $stateParams.user }).$promise,
                    draft: ApiUser.initDraft({ idAccount: $stateParams.user, withRelated: 'landscapeDone' }).$promise,
                })
            } else if ($stateParams.draft) {
                promises = $q.all({
                    users: [],
                    draft: DataAccess.getDraftById({ idDraft: $stateParams.draft, withRelated: 'landscapeDone,account,providerOffer' }).$promise,
                })
            } else {
                promises = $q.all({
                    users: [],
                    draft: DataAccess.createVendorDraft().$promise,
                })
            }

            promises.then((data) => {
                $scope.user = _.get(data, 'users[0]', null)
                if (!$scope.user && data.draft.account && data.draft.account.category !== 'user') {
                    $scope.user = data.draft.account
                }
                $scope.draft = _.omit(data.draft, 'account')
                $state.go($state.current, { draft: $scope.draft.id }, { notify: false })

                if (data.draft.status === 10) {
                    AlertManager.error('Ce draft a déjà été transformé en contrat.')
                    $scope.draftState.disableContractEdition = true
                } else if (data.draft.checkout_mail_sent || data.draft.ready_to_checkout) {
                    AlertManager.success('Un email de signature a déjà été envoyé à ce client.')
                    if (!data.draft.bulk_purchase) {
                        $scope.draftState.disableContractEdition = true
                    }
                }

                // Init data
                if (_.isNil($scope.draft.accept_contacts)) {
                    MetaWatcher.notif('SALES_TUNNEL.SAVE_DRAFT', { accept_contacts: false })
                }

                const dialMapping = {
                    'Base': 'base',
                    'Heures Pleines': 'hp',
                    'Heures Creuses': 'hc',
                }
                $scope.initialReadings = _.reduce(
                    $scope.draft.switchReadings,
                    (acc, reading) => _.assign({}, acc, { [dialMapping[reading.dial]]: _.toString(reading.value) }),
                    {}
                )

                MetaWatcher.notif('SALES_TUNNEL.SAVE_READINGS', $scope.initialReadings)
                MetaWatcher.notif('SALES_TUNNEL.SAVE_LANDSCAPE', {
                    landscapeDone: _.get($scope.draft, 'landscapeDone.done', false),
                    landscapeVersion: _.get($scope.draft, 'landscapeDone.version'),
                })

                // Init check status
                if ($scope.draft.checkout_mail_sent) {
                    $scope.saveChecks({
                        mailSent: $scope.draft.checkout_mail_sent,
                        mailVerified: false,
                        mandateSignature: !_.isEmpty($scope.draft.order_id),
                        transformed: $scope.draft.status === 10,
                        needInter: false,
                    })
                    EventProcessorService.register('SUBSCRIPTION_SUMMARY', data.draft.id, $scope, (event) => {
                        $scope.saveChecks({ mailVerified: true, mailBounced: false })
                    })
                    EventProcessorService.register('EMAIL_BOUNCED', $scope.user.id, $scope, (event) => {
                        $scope.saveChecks({ mailSent: false, mailBounced: true })
                    })
                    EventProcessorService.register('MANDATE_SIGNATURE', $scope.user.id, $scope, (event) => {
                        $scope.saveChecks({ mandateSignature: true })
                    })
                    EventProcessorService.register('CONTRACT_SIGNED', $scope.draft.id, $scope, (event) => {
                        $scope.saveChecks({ transformed: true, needInter: event.needInter })
                    })
                }
            }).catch((error) => {
                ErrorCatcher(error)
                $scope.draftState.error = error
            })
        })
    }

    // SAVE CONTRACT DRAFT
    $scope.draftServices = {
        shootDraft(draftPayload, bulkPurchaseMode = null, overrideEmail) {
            const draftPromise = _.isObject(draftPayload) ? $scope.saveDraft(draftPayload) : $q.resolve()
            draftPromise.then(() => {
                $scope.logShootDraft('Préparation de la création du contrat...')
                $scope.saveDraftState({ isSubmitting: true, disableContractEdition: true })
                if (bulkPurchaseMode) {
                    return $scope.draftServices.bulkPurchaseCheckout(bulkPurchaseMode, overrideEmail)
                }
                return $scope.draftServices.linkDraftToUser().then((data) => {
                    return $scope.draftServices.setDraftReadyToCheckout(data)
                })
            }).finally(() => {
                $scope.saveDraftState({ isSubmitting: false })
            })
        },

        bulkPurchaseCheckout(mode, overrideEmail) {
            $scope.logShootDraft(`Envoi ${mode === 'SMS' ? 'du SMS' : `de l'email`} pour finalisation de la commande`)
            const payload = {
                mode,
                overrideEmail: overrideEmail || undefined,
            }
            return ApiUser.bulkPurchaseCheckout({ id_draft: $scope.draft.id }, payload).$promise
            .then(() => {
                AlertManager.success(`${mode === 'SMS' ? 'SMS' : `Email`} envoyé !`)
                $scope.logShootDraft(`${mode === 'SMS' ? 'SMS' : `Email`} envoyé !`)
                _.assign($scope.draft, { checkout_mail_sent: true })
                $scope.validate()

                $scope.logShootDraft('En attente que l’utilisateur finalise la commande sur le portail web')
                $scope.saveChecks({ mailSent: true, mailBounced: false })

                EventProcessorService.register('MANDATE_SIGNATURE', $scope.draft.id_account, $scope, (event) => {
                    $scope.logShootDraft('L’utilisateur est sur le portail slimpay')
                    $scope.saveChecks({ mandateSignature: true })
                })

                EventProcessorService.register('CONTRACT_SIGNED', $scope.draft.id, $scope, (event) => {
                    $scope.logShootDraft('L’utilisateur a finalisé son contrat')
                    $scope.saveChecks({ transformed: true, needInter: event.needInter })
                })
            })
            .catch(ErrorCatcher)
        },

        signForClient(data) {
            $scope.logShootDraft('Préparation de la création du contrat...')
            $scope.saveDraftState({ isSubmitting: true, disableContractEdition: true })
            return DataAccess.updateDraftById({ id: $scope.draft.id }, _.assign({ ready_to_checkout: true }, data)).$promise
            .then(() => {
                return ApiUser.generateMandate({ idDraft: $scope.draft.id }).$promise.then((redirect) => {
                    $window.open(redirect.redirectUrl, '_blank')

                    EventProcessorService.register('MANDATE_SIGNATURE', $scope.draft.id_account, $scope, (event) => {
                        $scope.logShootDraft('L’utilisateur est sur le portail slimpay')
                        $scope.saveChecks({ mandateSignature: true })
                    })

                    EventProcessorService.register('CONTRACT_SIGNED', $scope.draft.id, $scope, (event) => {
                        $scope.logShootDraft('L’utilisateur a finalisé son contrat')
                        $scope.saveChecks({ transformed: true, needInter: event.needInter })
                    })
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.saveDraftState({ isSubmitting: false })
                })
            })
        },

        signForClientIFrame() {
            $scope.logShootDraft('Préparation de la création du contrat...')
            $scope.saveDraftState({ isSubmitting: true, disableContractEdition: true })
            $scope.draftServices.linkDraftToUser().then((data) => {
                return DataAccess.updateUserDraft({ idAccount: data.user.id }, { ready_to_checkout: true }).$promise.then((userDraft) => {
                    $scope.draft = userDraft
                    $scope.validate()
                    return userDraft
                }).then(() => {
                    EventProcessorService.register('MANDATE_SIGNATURE', $scope.draft.id_account, $scope, (event) => {
                        $scope.logShootDraft('L’utilisateur est sur le portail slimpay')
                        $scope.saveChecks({ mandateSignature: true })
                    })

                    EventProcessorService.register('CONTRACT_SIGNED', $scope.draft.id, $scope, (event) => {
                        $scope.logShootDraft('L’utilisateur a finalisé son contrat')
                        $scope.saveChecks({ transformed: true, needInter: event.needInter })
                    })

                    ModalService.openModal({ type: 'slimpaySignContractModal', size: 'lg' }, { idDraft: $scope.draft.id }, (result) => {
                        console.log('result', result)
                        $scope.saveDraftState({ isSubmitting: false })
                    })
                })
            })
        },

        saveSelfReport(idAccount, idDraft) {
            const selfReportable = !!((($scope.prm.id_p_calendar === 'BASE') && $scope.readings.base) ||
                (($scope.prm.id_p_calendar === 'HPHC') && $scope.readings.hc && $scope.readings.hp))
            return selfReportable
                ? DataAccess.draftSelfReport({ idAccount, idDraft }, $scope.readings).$promise
                : $q.resolve()
        },

        linkDraftToUser() {
            // Check User
            return $q.all({
                users: _.isEmpty($scope.user)
                    ? DataAccessSearch({ limit: 1 }).search({ resource: 'accounts', mail: $scope.draft.mail.toLowerCase() }).$promise
                    : [$scope.user],
            })
            .then((data) => {
                // Get First...
                if (data.users.length > 0) {
                    $scope.logShootDraft('Utilisateur existant trouvé')
                    $scope.saveUser(data.users[0])
                    return { user: data.users[0] }
                }

                // ... or create user
                $scope.logShootDraft('Création de l’utilisateur')
                const user = {
                    email: $scope.draft.mail,
                    givenName: $scope.draft.givenname.trim(),
                    sn: $scope.draft.sn.trim(),
                    civ: $scope.draft.civ,
                    givenName2: _.isEmpty($scope.draft.givenname2) ? undefined : $scope.draft.givenname2.trim(),
                    sn2: _.isEmpty($scope.draft.sn2) ? undefined : $scope.draft.sn2.trim(),
                    civ2: _.isEmpty($scope.draft.civ2) ? undefined : $scope.draft.civ2,
                    phone: $scope.draft.phone,
                    birth_date: moment($scope.draft.birth_date).format('YYYY-MM-DD'),
                }
                return ApiUser.newEndUser({ silent: true }, user).$promise.then(() => {
                    $scope.logShootDraft('Récupération de l’utilisateur créé')
                    return DataAccessSearch({ limit: 1 }).search({ resource: 'accounts', mail: $scope.draft.mail.toLowerCase() }).$promise
                }).then((users) => {
                    $scope.logShootDraft('Utilisateur créé récupéré')
                    $scope.saveUser(users[0])
                    return { user: users[0] }
                })
            })

            // Associate user to draft
            .then((data) => {
                $scope.logShootDraft('Association du contractDraft à l’utilisateur')
                return $q.all(_.assign({}, data, {
                    changeDraftOwner: ($scope.draft.id_account !== data.user.id)
                        ? ApiUser.changeDraftOwner({ idDraft: $scope.draft.id, idAccount: data.user.id }, {}).$promise
                        : $q.resolve(),
                }))
            })
            // Fetch & save up to date userDraft
            .then((data) => {
                $scope.logShootDraft('Récupération du contractDraft de l’utilisateur')
                return $q.all(_.assign({}, data, {
                    userDraft: DataAccess.userDraft({ idAccount: data.user.id }).$promise.then((userDraft) => {
                        $scope.draft = userDraft
                        $scope.validate()
                        return userDraft
                    }),
                }))
            })
            // Update birthdate
            .then((data) => {
                $scope.logShootDraft('Association du contractDraft à l’utilisateur')
                return $q.all(_.assign({}, data, {
                    userDraft: DataAccess.updateUserDraft(
                        { idAccount: data.user.id },
                        { birth_date: moment($scope.draft.birth_date).format('YYYY-MM-DD') }
                    ).$promise,
                }))
            })
            // Update self report
            .then((data) => {
                $scope.logShootDraft('Sauvegarde de l’autorelève')
                return $q.all(_.assign({}, data, {
                    draftSelfReport: $scope.draftServices.saveSelfReport(data.user.id, data.userDraft.id),
                }))
            })
        },

        setDraftReadyToCheckout(data) {
            if (data.userDraft.id_prm) {
                $scope.logShootDraft('Contrat prêt à être créé')
                return ApiUser.preshootUserDraft(
                    { idAccount: data.user.id, is_iban_from_mandate: $scope.draftState.usingMandateIban },
                    { ready_to_checkout: true }
                ).$promise.then((userDraft) => {
                    $scope.draft = userDraft
                    $scope.validate()
                    return userDraft
                }).then(() => {
                    $scope.logShootDraft('Envoi de l’email pour finalisation de la commande')
                    return ApiUser.sendCheckoutEmail({ id_draft_basic: data.userDraft.id }, {}).$promise
                }).then(() => {
                    $scope.logShootDraft('Email finalisation de la commande envoyé')
                    return DataAccess.updateUserDraft({ idAccount: data.user.id }, { checkout_mail_sent: true }).$promise.then((userDraft) => {
                        $scope.draft = userDraft
                        $scope.validate()
                        return userDraft
                    })
                }).then(() => {
                    $scope.logShootDraft('En attente que l’utilisateur finalise la commande sur le portail web')
                    $scope.saveChecks({ mailSent: true, mailBounced: false })

                    EventProcessorService.register('SUBSCRIPTION_SUMMARY', data.userDraft.id, $scope, (event) => {
                        $scope.logShootDraft('L’utilisateur a bien été redirigé sur le résumé de sa commande')
                        $scope.saveChecks({ mailVerified: true })
                    })
                    EventProcessorService.register('EMAIL_BOUNCED', data.user.id, $scope, (event) => {
                        $scope.logShootDraft('L’e-mail est revenu en erreur, vérifiez l\'adresse.')
                        $scope.saveChecks({ mailSent: false, mailBounced: true })
                    })

                    EventProcessorService.register('MANDATE_SIGNATURE', data.user.id, $scope, (event) => {
                        $scope.logShootDraft('L’utilisateur est sur le portail slimpay')
                        $scope.saveChecks({ mandateSignature: true })
                    })

                    EventProcessorService.register('CONTRACT_SIGNED', data.userDraft.id, $scope, (event) => {
                        $scope.logShootDraft('L’utilisateur a finalisé son contrat')
                        $scope.saveChecks({ transformed: true, needInter: event.needInter })
                    })
                    $state.go('salesTunnelV2', { draft: $scope.draft.id }, { reload: true })
                })
            }
            $scope.logShootDraft('Le contrat à déja été envoyé à l’utilisateur')
        },
    }

    // ACTIVATE
    const activate = function () {
        initWatchers()
        fetchInitialInfo()
    }

    $scope.enableEdition = () => {
        $scope.draftState.disableContractEdition = false
    }

    $scope.resetForm = () => {
        initData()
        fetchInitialInfo()
        $stateParams.user = undefined
        $state.transitionTo('salesTunnelV2', { user: undefined }, { notify: false, inherit: false })
    }
    activate()
})
